/** 
 * @description        抽检批次组件相关操作
 * @autor              shuxiaokai
 * @create             2020-05-14 09:34
 */

export default {
    /** 
     * @description        新增一个抽检批次组件
     * @autor              shuxiaokai
     * @create             2020-05-14 09:38
     */
    addSampleBatchWidget(state, payload) {
        const widget = {
            id: String(Date.now()),
            type: payload.type,
            //=====================================位置信息====================================//
            boundingClientRect: {
                left: payload.left, //相对父元素left
                top: payload.top, //相对父元素top
                width: payload.width, //宽度
                height: payload.height, //高度
                clientLeft: payload.clientLeft, //相对于父元素left
                clientTop: payload.clientTop, //相对于父元素top                
            },
            //=====================================样式相关配置====================================//
            backgroundColor: "#fff", //全局背景颜色
            textStyle: { //全局字体配置
                color: "",
                fontSize: 16,
            }, 
            //=====================================组件独特配置====================================//
            config: {
                title: "抽检批次数", //抽检批次数文案
                count: 999, //抽检批次数
            },
            //=====================================其他参数====================================//
            loading: false, //请求数据中
        };
        state.widgetList.push(widget);
    },
    /** 
     * @description        改变抽检批次组件自定义配置
     * @autor              shuxiaokai
     * @create             2020-05-14 09:59
     */
    changeSampleBatchSelfConfig(state, payload) {
        const { title, count } = payload;
        if (title) { //改变title
            state.config.title = title;
        }
        if (count) { //改变count
            state.config.count = count;
        }
    }

}



